import { IApplicationState } from '../../types/redux';

export const selectPartnerRewardsSource = (state: IApplicationState) => state.partnerRewardsSource;
